import { useEventBus } from '@vueuse/core'

const bus = useEventBus('filtering')

export default bus